import { createRouter, parseSearchWith, stringifySearchWith } from '@tanstack/react-router'
import { z } from 'zod'
import { RootError } from './components/errors/RootError.tsx'
import { SplashScreen } from './components/SplashScreen.tsx'
import { queryClient } from './query-client.ts'
import { routeTree } from './routeTree.gen.ts'

export const router = createRouter({
	routeTree,
	context: { queryClient, ldClient: undefined },
	notFoundMode: 'root',
	defaultPreloadStaleTime: 0,
	defaultPreload: 'intent',
	defaultStructuralSharing: true,
	defaultPendingComponent: SplashScreen,
	defaultErrorComponent: RootError,
	defaultOnCatch(error, errorInfo) {
		console.error(error, errorInfo)
	},
	parseSearch: parseSearchWith((s) => {
		if (s.includes('~')) return s.split('~')
		return JSON.parse(s)
	}),
	stringifySearch: stringifySearchWith((obj) => {
		if (Array.isArray(obj)) return obj.join('~')
		return JSON.stringify(obj)
	}),
})

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}
}

const HashSchema = z.string().transform((s) => {
	const params = new URLSearchParams(s)
	return { lat: safeParseFloat(params.get('lat')), lon: safeParseFloat(params.get('lon')), z: safeParseFloat(params.get('z')) }
})

const safeParseFloat = (value: unknown) => {
	const parsed = Number.parseFloat(String(value))
	return Number.isNaN(parsed) ? undefined : parsed
}

export const urlHash = {
	get: (): { lat?: number; lon?: number; z?: number } => {
		const hash = globalThis.location.hash
		const parsed = HashSchema.safeParse(hash.slice(1))
		if (parsed.success) return parsed.data

		console.error('Failed to parse hash:', parsed.error)
		return {}
	},
	format: (coords: { lat?: number; lon?: number; z?: number }) => {
		const params = new URLSearchParams()
		if (coords.lat != null && coords.lon != null) {
			params.set('lat', coords.lat.toFixed(5))
			params.set('lon', coords.lon.toFixed(5))
		}
		if (coords.z != null) params.set('z', coords.z.toFixed(3))
		return params.toString()
	},
}
